// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { OrderContext } from 'Contexts/OrderContext';

export default function useOrder() {
  return useContext(OrderContext);
}
